import { AxiosError } from "axios";
import { useMutation } from "react-query";
import axiosClient from "../utils/axiosClient";

export const useConversationFileMutation = () => {
  return useMutation<
    [string],
    AxiosError<any>,
    {
      files: File[];
    }
  >(
    ({ files }) => {
      const body = new FormData();
      files.forEach(file => {
        body.append("files", file);
      });

      return axiosClient
        .post(`/conversation/uploadFiles`, body, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 60 * 1000, // 1min
        })
        .then(({ data }) => data);
    },
    {
      retry: false,
    }
  );
};
